<template>
  <div id="propertyAddress">
    <multiselect
      ref="multiselect"
      v-model="propertyAddress"
      :options="addresses"
      :loading="isLoading"
      @search-change="getAddresses"
      :custom-label="getLabel"
      :class="{ 'border-bottom-blue': isPropertyAddressSet && !isLocationOpened }"
      open-direction="bottom"
      :searchable="true"
      placeholder="1 rue du Poteau"
      selectLabel=""
      selectedLabel=""
      deselectLabel=""
      :internal-search="false"
      :clear-on-select="false"
      :close-on-select="true"
      :max-height="300"
      :show-no-results="false"
      :hide-selected="true"
      @close="setIsLocationOpened(false)"
      @open="setIsLocationOpened(true)"
    >
      <span
        class="caret"
        slot-scope="{ toggle }"
        :class="{ 'border-blue': isPropertyAddressSet }"
        @mousedown.prevent.stop="toggle"
        slot="caret"
      ></span>
      <span slot="noResult">Aucun résultat...</span>
      <span slot="noOptions">Tapez pour chercher...</span>
      <template slot="option" slot-scope="props">
        <div class="option__desc">
          <span class="option__title">{{ props.option.properties.label }}</span>
        </div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import IconSubmit from "@/components/icons/IconSubmit.vue";
import { mapMutations, mapState, mapGetters } from "vuex";

export default {
  components: {
    Multiselect,
    IconSubmit,
  },
  data() {
    return {
      addresses: [],
      isLoading: false,
    };
  },
  computed: {
    ...mapState(["isLocationOpened"]),
    ...mapGetters(["isPropertyAddressSet"]),
    propertyAddress: {
      get() {
        return this.$store.state.optionalFields.propertyAddress;
      },
      set(value) {
        this.$store.commit("SET_PROPERTY_ADDRESS", value);
      },
    },
  },
  methods: {
    ...mapMutations({
      toggleFilter: "TOGGLE_FILTER",
      setIsLocationOpened: "SET_IS_LOCATION_OPENED",
    }),
    getLabel({ properties }) {
      return properties.label;
    },

    getAddresses(query) {
      if (typeof window.LIT !== "undefined") {
        clearTimeout(window.LIT);
      }
      if (query != "")
        window.LIT = setTimeout(() => {
          this.isLoading = true;
          let url = new URL("https://api-adresse.data.gouv.fr/search/");
          url.search = new URLSearchParams({
            q: query,
            limit: 15,
          });
          fetch(url, {
            method: "GET",
          })
            .then(response => response.json())
            .then(data => {
              this.addresses = data.features;
              this.isLoading = false;
            });
        }, 200);
    },
    focus() {
      this.$refs.multiselect.$el.focus();
    },
  },
  mounted() {
    if (this.$router.currentRoute.name != "dashboard") this.focus();
    this.$store.commit("SET_HAS_INPUT_BEEN_CHANGED", false);
  },
};
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/mixins";
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "@/styles/multiselect.scss";
.option__image {
  width: 1.2rem;
  margin-right: 0.5rem;
}
.multiselect {
  @include media-breakpoint-up(md) {
    width: 22rem;
  }
}
.multiselect__tags {
  padding-left: 0;
}
</style>
